import { render, staticRenderFns } from "./Interes_Simple_I_Uno.vue?vue&type=template&id=96452c8a&scoped=true&"
import script from "./Interes_Simple_I_Uno.vue?vue&type=script&lang=js&"
export * from "./Interes_Simple_I_Uno.vue?vue&type=script&lang=js&"
import style0 from "./Interes_Simple_I_Uno.vue?vue&type=style&index=0&id=96452c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96452c8a",
  null
  
)

export default component.exports